var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8983 5H7.22667C6.63612 5 6.06976 5.23459 5.65218 5.65218C5.23459 6.06976 5 6.63612 5 7.22667V15.8983C5 16.4889 5.23459 17.0552 5.65218 17.4728C6.06976 17.8904 6.63612 18.125 7.22667 18.125H15.8983C16.4889 18.125 17.0552 17.8904 17.4728 17.4728C17.8904 17.0552 18.125 16.4889 18.125 15.8983V7.22667C18.125 6.93426 18.0674 6.64471 17.9555 6.37456C17.8436 6.10441 17.6796 5.85894 17.4728 5.65218C17.2661 5.44541 17.0206 5.2814 16.7504 5.16949C16.4803 5.05759 16.1907 5 15.8983 5Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9808 5L15 4.0625C14.9982 3.48288 14.7672 2.9275 14.3574 2.51765C13.9475 2.10779 13.3921 1.87676 12.8125 1.875H4.375C3.71257 1.87698 3.07783 2.14101 2.60942 2.60942C2.14101 3.07783 1.87698 3.71257 1.875 4.375V12.8125C1.87676 13.3921 2.10779 13.9475 2.51765 14.3574C2.9275 14.7672 3.48288 14.9982 4.0625 15H5",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.8f191b0da09b275b3ebfd51e167cd03e.svg";
export { ForwardRef as ReactComponent };